<app-generic-table
  id="reg-fav-table"
  [config]="tableConfig"
  [data]="favorites"
  [isLoading]="isLoading"
  [noDataMessage]="noDataMessage"
  [page]="page"
  [pageSize]="perPage"
  [totalRegisters]="totalRegisters"
  (pageChange)="changePage($event)"
  >
  <ng-template appTableCell="_icon" let-favorite>
    <img id="reg-fav-img-icon-{{favorite.id || favorite.document}}" [src]="getFavoriteIcon()" alt="Favorite icon" style="max-width: 30px" />
  </ng-template>

  <ng-template appTableCell="document" let-favorite>
    @if (personType === 'PERSON') {
      <span id="reg-fav-span-doc-person-{{favorite.id || favorite.document}}">{{ favorite.document | cpfMask }}</span>
    }
    @if (personType === 'COMPANY') {
      <span id="reg-fav-span-doc-company-{{favorite.id || favorite.document}}">{{ favorite.document | cnpjMask }}</span>
    }
  </ng-template>

  <ng-template appTableCell="_actions" let-favorite>
    <div class="actions-column">
      @if (showAdminActions) {
        <a
          id="reg-fav-btn-delete-{{favorite.id || favorite.document}}"
          (click)="handleDelete(favorite)"
          [ngClass]="{ inactive: favorite.base }"
          matTooltip="Excluir Documento"
          i18n-matTooltip="@@deleteDocument"
          matTooltipClass="custom-tooltip"
          >
          <em class="far fa-trash-alt"></em>
        </a>
      }
      @if (showAdminActions) {
        <a
          id="reg-fav-btn-edit-{{favorite.id || favorite.document}}"
          (click)="handleEdit(favorite)"
          [ngClass]="{ inactive: favorite.base }"
          matTooltip="Editar Documento"
          i18n-matTooltip="@@registerEdition"
          matTooltipClass="custom-tooltip"
          >
          <em class="fas fa-pencil-alt"></em>
        </a>
      }
      <a
        id="reg-fav-btn-toggle-{{favorite.id || favorite.document}}"
        (click)="toggleFavorite(favorite)"
        matTooltip="Remover dos Favoritos"
        i18n-matTooltip="@@removeFavorites"
        matTooltipClass="custom-tooltip"
        >
        <em [class]="favorite.isFavorite ? 'fas fa-star' : 'far fa-star'"></em>
      </a>
    </div>
  </ng-template>
</app-generic-table>
